import dynamic from 'next/dynamic';
export * from './types';

/** react pure carousel is shown in reduce unused javascript error on lighthouse analytics
 * in order to remove this error we need to import those component dynamicaly
 */
export const ResponsiveCarousel = dynamic<any>(() => import('./ResponsiveCarousel') as any) as any;
